// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"0f713422","455":"0d461384","482":"b5e35877","544":"3e84228f","579":"417b26d2","708":"e943a84d"}[chunkId] + ".chunk.js";
};